import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { connect } from "react-redux";

import { Sidebar, Header } from '../../../common/components/layout';
import Message from '../../../common/components/message/message';

import MenuAdmin from './menu-admin';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
        htmlFontSize: 8,
    },
});

class ModuleAdmin extends Component {
    constructor(props){
        super(props);
        if (!this.props.auth.user.is_admin) {
            window.location.replace('/#/401');
        }
    }
    
    render() {
        if (!this.props.auth.user.is_admin) {
            return null;
        }
        return (
            <MuiThemeProvider theme={theme}>
                <div className='wrapper'>
                    <Header />
                    <Sidebar>
                        <MenuAdmin />
                    </Sidebar>
                    <div className="content-wrapper">
                        <div className="container-fluid" style={{fontSize: '1.6rem'}}>
                            {this.props.children}
                        </div>
                    </div>
                    {/* <Footer /> */}
                    <Message />
                </div>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = null;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModuleAdmin);